import knowledgeBase from './knowledge_base.vue';

export default knowledgeBase;
